import { setClusterValueFilter as setClusterValueFilterDiagram , updateDiagramCluster} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    valueFilter?: string,
}

export const applyClusterValueFilter = ({
    valueFilter,
    eventEmitter,
}: Props) => {
    setClusterValueFilterDiagram(valueFilter);
    apiProvider.updateDiagramCluster({source : 'applyClusterValueFilter'});
    eventEmitter.emit(Event.applyFilter);
};
